function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHidePassword = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 34 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.761,1.321C2.232,0.905 1.466,1.001 1.049,1.529C0.633,2.058 0.729,2.824 1.257,3.241L31.321,26.804C31.849,27.221 32.616,27.124 33.033,26.596C33.449,26.068 33.353,25.301 32.825,24.885L27.482,20.7C29.493,18.638 30.854,16.328 31.54,14.687C31.707,14.286 31.707,13.839 31.54,13.438C30.783,11.625 29.193,8.984 26.817,6.78C24.43,4.556 21.144,2.687 17.041,2.687C13.578,2.687 10.693,4.023 8.443,5.775L2.761,1.321ZM12.12,8.654C13.415,7.471 15.147,6.75 17.041,6.75C21.078,6.75 24.354,10.026 24.354,14.063C24.354,15.327 24.034,16.516 23.47,17.552L21.51,16.018C21.774,15.419 21.916,14.759 21.916,14.063C21.916,11.371 19.732,9.188 17.041,9.188C16.899,9.188 16.757,9.193 16.614,9.208C16.884,9.68 17.041,10.229 17.041,10.813C17.041,11.331 16.919,11.818 16.706,12.25L12.12,8.654ZM23.45,23.788L19.732,20.863C18.9,21.193 17.991,21.376 17.041,21.376C13.004,21.376 9.728,18.1 9.728,14.063C9.728,13.712 9.754,13.372 9.799,13.037L5.01,9.264C3.852,10.772 3.025,12.275 2.542,13.438C2.375,13.839 2.375,14.286 2.542,14.687C3.299,16.5 4.888,19.141 7.265,21.345C9.652,23.57 12.938,25.438 17.041,25.438C19.468,25.438 21.606,24.783 23.45,23.788Z",
    style: {
      fill: "#ccc",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHidePassword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hide-password.2785860868efd0c0a3ec2e3d83423524.svg";